import React, { useEffect, useState } from "react";
import { Row, Col, Avatar, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { ROLE_USER, USER_STORAGE } from "constants/index";
import { GetPropsHeader } from "./header-custom";

const { Text } = Typography;
const font = "'Montserrat', sans-serif";
const Header = ({ logout }) => {
  const [userName, setUserName] = useState("");
  const customHeader = GetPropsHeader(location.pathname);

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { name, companyName, role } = JSON.parse(localStorageItem);
      if (ROLE_USER == role) {
        setUserName(companyName);
      } else {
        setUserName(name);
      }
    }
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "10px",
        background: "#E0E2E7",
      }}
    >
      <div style={{ flex: 1, marginLeft: "30px" }}>
        {customHeader.pathIcon}
        <Text strong style={{ fontFamily: font, color: "#9FA1AA" }}>
          {customHeader.pathName}
        </Text>
      </div>
      <div style={{ marginRight: "20px", textAlign: "end" }}>
        <Text strong style={{ fontFamily: font }}>
          {userName}
        </Text>
        <br />
        <div
          className="logout"
          style={{
            fontFamily: font,
            cursor: "pointer",
          }}
          onClick={logout}
        >
          Sair
        </div>
      </div>
      <Row align="middle">
        <Col>
          <Avatar icon={<UserOutlined />} size={40} />
        </Col>
      </Row>
    </div>
  );
};

export default Header;
